<template>
    <div
        role="alert"
        class="notifications-bar">
        <transition-group
            name="slide-up"
            tag="div">
            <div
                v-for="item in items"
                :show="item.show"
                class="notification"
                :class="`notification--${item.type}`"
                :key="item.key">
                <svg
                    v-if="item.type !== 'success'"
                    class="notification__icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20">
                    <path
                        id="_Color"
                        d="M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM9,13v2h2V13ZM9,5v6h2V5Z"
                        fill="#fff"/>
                </svg>
                <p class="notification__text">{{ item.message }}</p>
            </div>
        </transition-group>
    </div>
</template>

<script>
const key = () => `${Date.now()}-${Math.random()}`;
// import IwDialog from "./Dialog";

export default {
    components: {
    },

    data() {
        return {
            items: [],
        };
    },

    created() {
        window.addEventListener("keyup", this.keyUp);
    },

    methods: {
        open: function(message, options) {
            if (!this.$parent) {
                this.$mount();
                document.body.appendChild(this.$el);
            }
            return new Promise(resolve => {
                const item = {
                    key: key(),
                    show: true,
                    message,
                    type: options.type,
                };

                this.items.push(item);

                const timeOutId = window.setTimeout(() => {

                    window.clearTimeout(timeOutId);

                    let i = this.items.indexOf(item);
                    if (i >= 0) {
                        this.items.splice(i, 1);
                    }
                }, options.delay);
            });
        },

        alert: function(message, { type = "neutral", delay = 6000 } = {}) {
            return this.open(message, {type, delay});
        },

        // remove: function(item) {
        //     window.clearTimeout(this.timeoutId);

        //     let i = this.items.indexOf(item);
        //     if (i >= 0) {
        //         this.items.splice(i, 1);
        //     }
        // },
    },
};
</script>